import { WorkflowStatus } from '~/atoms/schemas/workflowSchemas';
import { TaskStatusBadge } from '~/components/ui/common/TaskStatusBadge';

type StatusCellRendererProps = {
  value: WorkflowStatus;
};

export const StatusCellRenderer = (props: StatusCellRendererProps) => {
  const status = props.value;

  return (
    <div className="flex align-items-center justify-content-center flex-grow-1">
      <TaskStatusBadge status={status} className="font-medium" />
    </div>
  );
};

export default StatusCellRenderer;
